/**
 * The slot controls on a Day timeline row (moved out of TimelineRow,
 * 19/10/2026): Skip today and Disable slot on hover for a plan-owned drop,
 * Reset on one a person took. Optimizer and hit-again drops have no slot row.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DayPlanDropRow } from '../../../drop-generator.types';

const QUIET = 'rounded border border-border/60 px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground';

interface Props {
  containerId: string;
  drop: DayPlanDropRow;
  onResetSlot?: (slotId: string) => void;
  onSkipSlot?: (slotId: string) => void;
  onDisableSlot?: (containerId: string, slotId: string) => void;
}

export const SlotActions: FC<Props> = ({ containerId, drop, onResetSlot, onSkipSlot, onDisableSlot }) => {
  const humanOwned = Boolean(drop.runtime?.tombstoned || drop.runtime?.pinned);
  const slotId = drop.optimizer || drop.hitAgain ? null : drop.slotId;
  if (!slotId) return null;
  if (humanOwned)
    return onResetSlot ? (
      <button type="button" onClick={() => onResetSlot(slotId)} className={`${QUIET} hover:bg-muted hover:text-foreground`}>
        Reset
      </button>
    ) : null;
  return (
    <>
      {drop.runtime && onSkipSlot ? (
        <button type="button" onClick={() => onSkipSlot(slotId)} title="Hold this slot for today (deletes its draft if one exists) — Reset undoes it" className={`${QUIET} opacity-0 transition-opacity hover:bg-muted hover:text-foreground group-hover:opacity-100`}>
          Skip today
        </button>
      ) : null}
      {onDisableSlot ? (
        <button type="button" onClick={() => onDisableSlot(containerId, slotId)} title="Turns this slot OFF in the container — gone from every day, today's draft removed. Re-enable it in the editor's Drop slots." className={`${QUIET} opacity-0 transition-opacity hover:bg-destructive/10 hover:text-destructive group-hover:opacity-100`}>
          Disable slot
        </button>
      ) : null}
    </>
  );
};
